import { logger, sanitizeError } from '@heidi/runtime/logger';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { deactivatePromotedFreeTrial } from '../api/trials';
import { invalidateCurrentUserBillingInfo } from '../query/useQueryUserBillingInfo';

const DEACTIVATE_PROMOTED_FREE_TRIAL_MUTATION_KEY = 'DEACTIVATE_PROMOTED_FREE_TRIAL';

export type UseDeactivatePromotedFreeTrialMutationProps = {
  // User refresh is a foreign-domain reaction. Callers bind the composite invalidation.
  onRefreshUser?: () => void;
  onDowngradedNotice?: () => void;
  onDowngradeFailedNotice?: () => void;
};

export function useDeactivatePromotedFreeTrialMutation({
  onRefreshUser,
  onDowngradedNotice,
  onDowngradeFailedNotice,
}: UseDeactivatePromotedFreeTrialMutationProps = {}): UseMutationResult<
  void,
  Error,
  void
> {
  return useMutation<void, Error, void>({
    mutationKey: [DEACTIVATE_PROMOTED_FREE_TRIAL_MUTATION_KEY],
    mutationFn: async () => {
      await deactivatePromotedFreeTrial();
    },
    onSuccess: () => {
      onRefreshUser?.();
      void invalidateCurrentUserBillingInfo();
      onDowngradedNotice?.();
    },
    onError: (error: unknown) => {
      logger.error('Failed to revert promoted free trial', sanitizeError(error));
      onDowngradeFailedNotice?.();
    },
  });
}
